import {
  DefaultStatus,
  TypedFormikReturn,
} from '@dai/components/src/formik/types'
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
  useTheme,
} from '@mui/material'
import React from 'react'

import { ActionType } from '@/graphql'

import { CreateFormValues } from './CreateRestockAction'

export const ActionTypeCard = ({
  type,
  title,
  description,
  formik,
  onNextStep,
}: {
  type: ActionType
  title: string
  description: string
  formik: TypedFormikReturn<CreateFormValues, DefaultStatus>
  onNextStep: () => void
}) => {
  const theme = useTheme()

  return (
    <Card
      variant="outlined"
      sx={{
        borderColor:
          formik.values.actionType === type
            ? theme.palette.primary.main
            : undefined,
        flex: 1,
        maxWidth: 300,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CardActionArea
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
        onClick={() => {
          formik.setValues({
            ...formik.values,
            actionType: type,
          })
          onNextStep()
        }}
      >
        <CardContent
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Typography variant="h6" gutterBottom>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}
